import router from "./router/index";
const whiteList = ["/", "/login", '/invite', '/mobilepdf'];
router.beforeEach((to, from, next) => {
  // console.log("页面跳转", "从", from.path, "到", to.path);
  // 获取  token
  const token = localStorage.getItem("token");
  // 是否有 token ？
  if (token) {
    // 有 token
    // 是否去登录页 ？
    if (to.path === "/login" || to.path === "/") {
      // 去登录页
      next("/record/ask"); // 回首页
      // console.log("用户已经登录，不能去登录页面");
    } else {
      // 不去登录页
      next(); // 放行
    }
  } else {
    // console.log(454);
    // 没有 token
    // 是否去白名单 ？
    if (whiteList.includes(to.path)) {
      // 去白名单
      next(); // 放行
    } else {
      // 不去白名单
      next("/"); // 去选择页
    }
  }
});
